import React, { useState } from 'react';
import { useCardStyles, useOtherStyles } from '../../App';
import { Notification } from '../../@types';
import { deleteNotification, getNotifications } from '../../axios/user';
import Typography from '@material-ui/core/Typography';
import ItemList from '../../common/List/ItemList';
import AddIcon from '@material-ui/icons/Add';
import SubmitButton from '../../common/Button/SubmitButton';
import { AppBar, CardHeader, Divider } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import { Cancel, Visibility } from '@material-ui/icons';
import theme from '../../theme';
import makeStyles from '@material-ui/core/styles/makeStyles';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Popover from '@material-ui/core/Popover';
import Badge from '@material-ui/core/Badge';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(() => ({
	noNotifications: {
		textAlign: 'center',
		marginTop: '20px',
	},
	notifications: {
		color: theme.palette.common.white,
	},
	badge: {
		padding: '0 4px',
	},
	popupButton: {
		width: '250px',
		padding: '10px',
		minHeight: '100px',
		backgroundColor: theme.palette.primary.main,
	},
	notificationCard: {
		backgroundColor: theme.palette.primary.light,
		borderRadius: '0px',
		margin: '8px 0px 0px',
	},
	notificationContent: {
		// borderBottom: '1px solid white'
		cursor: 'pointer',
		padding: '10px',
	},
	notificationTitle: {
		color: theme.palette.common.white,
	},
	notificationSubtitle: {
		color: theme.palette.grey[500],
	},
	notificationActions: {
		backgroundColor: theme.palette.primary.dark,
		padding: '1px 5px',
		color: theme.palette.grey[500]
	},
	notificationActionOption: {
		color: theme.palette.grey[500]
	},
	actionIcon: {
		marginRight: '5px'
	}
}));

const Notifications = () => {
	// const [open, setOpen] = useState(false);
	const history = useHistory();
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
		null
	);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const [Notifications, setNotifications] = React.useState<Notification[]>(
		[]
	);
	React.useEffect(() => {
		getNotifications()
			.then((res: any) => {
				setNotifications(res.data);
			})
			.catch((err: any) => console.log(err));
	}, []);

	const handleDismissNotification = (notification: Notification) => {
		deleteNotification(notification)
			.then((res: any) => {
				getNotifications()
					.then((res: any) => {
						setNotifications(res.data);
					})
					.catch((err: any) => console.log(err));
			})
			.catch((err: any) => console.log(err));
	};

	const handleViewNotification = (notification: Notification) => {
		alert('Implement view notification');
		handleDismissNotification(notification)
		history.push(`/${notification.messageType}s/details/${notification.object_id}`)
	};

	return (
		<>
			<IconButton
				onClick={handleClick}
				className={classes.notifications}
				aria-label='cart'
			>
				<Badge
					className={classes.badge}
					badgeContent={Notifications.length}
					color='secondary'
				>
					<NotificationsIcon />
				</Badge>
			</IconButton>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center',
				}}
			>
				<Box className={classes.popupButton}>
					<Box boxShadow={3} bgcolor={theme.palette.secondary.dark}>
						<Typography align='center'>Notifications</Typography>
					</Box>

					{Notifications.length == 0 ? (
						<Typography className={classes.noNotifications}>
							None
						</Typography>
					) : (
						Notifications.map((notification: Notification) => {
							return (
								<>
									<Box
										boxShadow={3}
										className={classes.notificationCard}
									>
										<Box
											className={
												classes.notificationContent
											}
											onClick={() =>
												handleViewNotification(
													notification
												)
											}
										>
											<Typography
												variant='subtitle1'
												className={
													classes.notificationTitle
												}
											>
												New {notification.messageType}!
											</Typography>
											<Typography
												variant='subtitle2'
												className={
													classes.notificationSubtitle
												}
											>
												{notification.message}
											</Typography>
										</Box>
										<Divider color='secondary' />
										<Box
											className={
												classes.notificationActions
											}
										>
											<Grid container xs={12}>
												<Grid item xs={6}>
													<IconButton
														onClick={() =>
															handleViewNotification(
																notification
															)
														}
														aria-label='View'
														className={classes.notificationActionOption}
													>
														<Visibility fontSize='small' className={classes.actionIcon} />
														<Typography variant='caption'>
															View
														</Typography>
													</IconButton>
												</Grid>
												<Grid item xs={6}>
													<IconButton
														onClick={() =>
															handleDismissNotification(
																notification
															)
														}
														aria-label='Dismiss'
														className={classes.notificationActionOption}
													>
														<Cancel fontSize='small' className={classes.actionIcon} />
														<Typography variant='caption'>
															Dismiss
														</Typography>
													</IconButton>
												</Grid>
											</Grid>
										</Box>
									</Box>
								</>
							);
						})
					)}
				</Box>
			</Popover>
		</>
	);
};

export default Notifications;
